import React, { useState, useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import { makeStyles, Paper, Tabs, Tab } from "@material-ui/core";

import TabPanel from "../../components/TabPanel";

import SchedulesForm from "../../components/SchedulesForm";
// import CompaniesManager from "../../components/CompaniesManager"; // ✅ NO USADO - Reemplazado por CompaniesManagerImproved
import CompaniesManagerImproved from "../../components/CompaniesManager/CompaniesManagerImproved";
// import HelpsManager from "../../components/HelpsManager"; // ✅ NO USADO - Reemplazado por HelpsManagerImproved
import HelpsManagerImproved from "../../components/HelpsManager/HelpsManagerImproved";
import Options from "../../components/Settings/Options";
// import SMTPConfig from "../../components/Settings/SMTPConfig"; // ⚠️ DEPRECADO - Reemplazado por SMTPConfigManager
import SubscriptionsConfig from "../../components/Settings/SubscriptionsConfig";
import WebConfig from "../../components/Settings/WebConfig";
// import Performance from "../../components/Settings/Performance"; // ✅ MOVIDO A Dashboard > Rendimiento CPU
import VersionInfo from "../../components/Settings/VersionInfo";
// ✅ NUEVO: Componente DB-FIRST para SMTP (incluye Plantillas internamente)
import SMTPConfigManager from "../Settings/components/SMTPConfigManager";
// ✅ NUEVO: Componente para notificaciones VPS
import NotificationAlertsConfig from "../Settings/components/NotificationAlertsConfig";
import TelegramBotConfig from "../Settings/components/TelegramBotConfig";

import { i18n } from "../../translate/i18n.js";
import { toast } from "react-toastify";

import useCompanies from "../../hooks/useCompanies";
import useAuth from "../../hooks/useAuth.js";
import useSettings from "../../hooks/useSettings";

import OnlyForSuperUser from "../../components/OnlyForSuperUser";

const sectionToTab = {
  opciones: "options",
  options: "options",
  horarios: "schedules",
  schedules: "schedules",
  versiones: "version",
  version: "version",
  smtp: "smtp",
  alertas: "alerts",
  alerts: "alerts",
  telegram: "telegram",
  subscripciones: "subscriptions",
  subscriptions: "subscriptions",
  web: "web",
  empresas: "companies",
  companies: "companies",
  ayudas: "helps",
  helps: "helps",
};

const tabToSection = {
  options: "",
  schedules: "horarios",
  version: "versiones",
  smtp: "smtp",
  alerts: "alertas",
  telegram: "telegram",
  subscriptions: "subscripciones",
  web: "web",
  companies: "empresas",
  helps: "ayudas",
};

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
    backgroundColor: theme.palette.background.paper,
  },
  mainPaper: {
    ...theme.scrollbarStyles,
    overflowY: "auto",
    overflowX: "hidden",
    flex: 1,
    minWidth: 0,
    maxWidth: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  // ✅ CORREGIDO: Estilos para contenedor de Tabs
  tabsContainer: {
    backgroundColor: theme.palette.background.paper,
    "& .MuiTabs-root": {
      backgroundColor: theme.palette.background.paper,
      borderBottom: `1px solid ${theme.palette.divider || (theme.mode === 'dark' ? '#374151' : '#e0e0e0')}`,
    },
    "& .MuiTabs-flexContainer": {
      backgroundColor: theme.palette.background.paper,
    },
    "& .MuiTab-root": {
      color: theme.palette.text.primary,
      backgroundColor: theme.palette.background.paper,
      "&:hover": {
        backgroundColor: theme.mode === 'dark' ? '#374151' : '#f5f5f5',
      },
      "&.Mui-selected": {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.paper,
      },
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tab: {
    backgroundColor: theme.palette.options,
    borderRadius: 4,
  },
  paper: {
    ...theme.scrollbarStyles,
    overflowY: "auto",
    overflowX: "hidden",
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.paper,
  },
  container: {
    width: "100%",
    minWidth: 0,
    maxWidth: "100%",
    maxHeight: "100%",
    boxSizing: "border-box",
  },
  control: {
    padding: theme.spacing(1),
  },
  textfield: {
    width: "100%",
  },
}));

const SettingsCustom = () => {
  const classes = useStyles();
  const history = useHistory();
  const { section } = useParams();
  const [tab, setTab] = useState(sectionToTab[section] || "options");
  const [schedules, setSchedules] = useState([]);
  const [company, setCompany] = useState({});
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState({});
  const [settings, setSettings] = useState({});
  const [schedulesEnabled, setSchedulesEnabled] = useState(false);

  const { getCurrentUserInfo } = useAuth();
  const { find, updateSchedules } = useCompanies();
  const { getAll: getAllSettings } = useSettings();

  const settingsErrorMessage = (error) =>
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    i18n.t("settings.error");

  const isSuperUser = Boolean(
    currentUser?.super || currentUser?.profile === "super"
  );

  const resolveTab = (requestedTab, { schedulesOn, superUser }) => {
    const requested = requestedTab || "options";
    if (requested === "schedules" && !schedulesOn) return "options";
    const superOnly = ["version", "smtp", "alerts", "telegram", "subscriptions", "web", "companies", "helps"];
    if (superOnly.includes(requested) && !superUser) return "options";
    return requested;
  };

  useEffect(() => {
    const requested = sectionToTab[section] || "options";
    const userLoaded = Boolean(currentUser?.id || currentUser?.profile);
    setTab(
      resolveTab(requested, {
        schedulesOn: schedulesEnabled,
        superUser: userLoaded ? isSuperUser : true,
      })
    );
  }, [section, schedulesEnabled, isSuperUser, currentUser]);

  useEffect(() => {
    async function findData() {
      setLoading(true);
      try {
        const companyId = localStorage.getItem("companyId");
        const company = await find(companyId);
        const settingList = await getAllSettings();
        setCompany(company);
        setSchedules(company.schedules);
        setSettings(settingList);

        if (Array.isArray(settingList)) {
          const scheduleType = settingList.find(
            (d) => d.key === "scheduleType"
          );
          if (scheduleType) {
            setSchedulesEnabled(scheduleType.value === "company");
          }
        }

        const user = await getCurrentUserInfo();
        setCurrentUser(user);
      } catch (e) {
        toast.error(settingsErrorMessage(e));
      }
      setLoading(false);
    }
    findData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleTabChange = (_event, newValue) => {
    const nextSection = tabToSection[newValue];
    const nextPath = nextSection ? `/settings/${nextSection}` : "/settings";
    if (history.location.pathname !== nextPath) {
      history.push(nextPath);
    }
  };

  const handleSubmitSchedules = async (data) => {
    setLoading(true);
    try {
      setSchedules(data);
      await updateSchedules({ id: company.id, schedules: data });
      toast.success(i18n.t("settings.schedules.success"));
    } catch (e) {
      toast.error(settingsErrorMessage(e));
    }
    setLoading(false);
  };

  const handleScheduleTypeChanged = (value) => {
    const enabled = value === "company";
    setSchedulesEnabled(enabled);
    if (!enabled && (tab === "schedules" || sectionToTab[section] === "schedules")) {
      history.push("/settings");
    }
    setSettings((prevSettings) => {
      if (!Array.isArray(prevSettings)) return prevSettings;

      const settingIndex = prevSettings.findIndex((s) => s.key === "scheduleType");
      if (settingIndex === -1) {
        return [...prevSettings, { key: "scheduleType", value }];
      }

      return prevSettings.map((setting, index) =>
        index === settingIndex ? { ...setting, value } : setting
      );
    });
  };

  const isSuper = () => isSuperUser;

  return (
    <MainContainer className={classes.root}>
      <MainHeader>
        <Title>{i18n.t("settings.title")}</Title>
      </MainHeader>
      <Paper className={classes.mainPaper} elevation={1}>
        <div className={classes.tabsContainer}>
          <Tabs
            key={i18n.language}
            value={tab}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="on"
            variant="scrollable"
            onChange={handleTabChange}
          >
            <Tab label={i18n.t("settings.tabs.options")} value={"options"} />
            {schedulesEnabled && <Tab label={i18n.t("settings.tabs.schedules")} value={"schedules"} />}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.version")} value={"version"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.smtp")} value={"smtp"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.alerts")} value={"alerts"} /> : null}
            {isSuper() ? <Tab label="Bot Telegram" value={"telegram"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.subscriptions")} value={"subscriptions"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.logo")} value={"web"} /> : null}
            {/* ✅ ELIMINADO: Tab "Rendimiento" movido a Dashboard > Rendimiento CPU */}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.companies")} value={"companies"} /> : null}
            {isSuper() ? <Tab label={i18n.t("settings.tabs.help")} value={"helps"} /> : null}
          </Tabs>
        </div>
        <Paper className={classes.paper} elevation={0}>
          <TabPanel
            className={classes.container}
            value={tab}
            name={"schedules"}
          >
            <SchedulesForm
              loading={loading}
              onSubmit={handleSubmitSchedules}
              initialValues={schedules}
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"companies"}
              >
                <CompaniesManagerImproved />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel
                className={classes.container}
                value={tab}
                name={"helps"}
              >
                <HelpsManagerImproved />
              </TabPanel>
            )}
          />
          <TabPanel className={classes.container} value={tab} name={"options"}>
            <Options
              settings={settings}
              scheduleTypeChanged={handleScheduleTypeChanged}
            />
          </TabPanel>
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"version"}>
                <VersionInfo />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"smtp"}>
                <SMTPConfigManager />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"alerts"}>
                <NotificationAlertsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"telegram"}>
                <TelegramBotConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"subscriptions"}>
                <SubscriptionsConfig />
              </TabPanel>
            )}
          />
          <OnlyForSuperUser
            user={currentUser}
            yes={() => (
              <TabPanel className={classes.container} value={tab} name={"web"}>
                <WebConfig />
              </TabPanel>
            )}
          />
          {/* ✅ ELIMINADO: TabPanel "performance" movido a Dashboard > Rendimiento CPU */}
        </Paper>
      </Paper>
    </MainContainer>
  );
};

export default SettingsCustom;
